export const ESSENTIALS_TRIAL_PLAN = 'essentials_v2_trial';
export const PODIUM_TRIAL_PLAN = 'podium_trial';
export const PROFESSIONAL_TRIAL_PLAN = 'professional_trial';
export const ESSENTIALS_PAID_PLAN = 'essentials_v2';
export const PODIUM_PAID_PLAN = 'podium';
export const PROFESSIONAL_PAID_PLAN = 'professional';

export const MONTHLY_TERM = 'monthly';
export const YEARLY_TERM = 'annual';

export const TRIAL_PLANS = {
  [ESSENTIALS_TRIAL_PLAN]: {
    annualPrice: '',
    displayName: 'Podium Essentials Plan',
    monthlyPrice: '289',
    plan: ESSENTIALS_TRIAL_PLAN,
    paid: ESSENTIALS_PAID_PLAN,
  },
  [PODIUM_TRIAL_PLAN]: {
    annualPrice: '',
    displayName: 'Podium Plan',
    monthlyPrice: '449',
    plan: PODIUM_TRIAL_PLAN,
    paid: PODIUM_PAID_PLAN,
  },
  [PROFESSIONAL_TRIAL_PLAN]: {
    annualPrice: '',
    displayName: 'Professional Plan',
    monthlyPrice: '649',
    plan: PROFESSIONAL_TRIAL_PLAN,
    paid: PROFESSIONAL_PAID_PLAN,
  },
};

export const TRIAL_PLAN_NAMES = {
  [ESSENTIALS_TRIAL_PLAN]: 'Podium Essentials Plan',
  [PODIUM_TRIAL_PLAN]: 'Podium Plan',
  [PROFESSIONAL_TRIAL_PLAN]: 'Podium Professional Plan',
};

export const TRIAL_ACCOUNT_STEP = 'account';
export const TRIAL_ONBOARDING_STEP = 'onboarding';
export const TRIAL_PAYMENT_STEP = 'payment-info';

export const TOTAL_STEPS = 2;

export const PRICING_URL = 'https://www.podium.com/pricing/';
